export default __webpack_public_path__ + "static/media/eb-pro-blk-poster-2.4e02c04a.jpg";